module.exports = __webpack_public_path__ + "static/img/shiping_thumb.6709eb41.jpg";